/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

import PropTypes from 'prop-types';
import styles from './styles/controls.css';

export const PlayButton = ({paused, play}) => (
  <i
    className={`${paused ? styles.playButton : styles.hidden}`}
    title={'Play'}
    onClick={() => play()}
  />
);

PlayButton.propTypes = {
  paused: PropTypes.bool.isRequired,

  play: PropTypes.func.isRequired
};

export default PlayButton;